import L from 'leaflet';
import { ref } from 'vue';
import { useStore } from 'vuex';
import 'leaflet-draw';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

export default function useBoundaryMap() {
  const store = useStore();
  const { track } = useTrack();

  let map, rectangleDrawer, coordinates;
  const maxY = ref(46.46197637);
  const minX = ref(48.92635369);
  const maxX = ref(-38.07473743);
  const minY = ref(-20.1608484);
  const extentVisible = ref(false);
  const dialogVisible = ref(false);

  const initDrawMap = () => {
    map = L.map('draw-map', {
      attributionControl: false,
      zoomControl: false,
    }).setView([39.9042, 116.4074], 5);
    L.tileLayer(process.env.VUE_APP_BASEMAP_XIANHUA, {
      subdomains: ['1', '2', '3']
    }).addTo(map);
    const drawnItems = new L.FeatureGroup().addTo(map);
    rectangleDrawer = new L.Draw.Rectangle(map);

    map.on(L.Draw.Event.CREATED, (e) => {
      const layer = e.layer;
      drawnItems.addLayer(layer);
      coordinates = layer.getLatLngs();
    });

    map.on(L.Draw.Event.DRAWSTART, () => {
      drawnItems.clearLayers();
    });
  };

  const startDraw = () => {
    rectangleDrawer.enable();
  };

  const refreshMainMapByExtent = () => {
    const { mainMap } = store.state.exportStore.mapData;
    if (mainMap) {
      const bounds = [
        [minY.value, minX.value],
        [maxY.value, maxX.value],
      ];
      mainMap.fitBounds(bounds);
    }
  };

  const refreshExtentByMainMap = () => {
    const { mainMap } = store.state.exportStore.mapData;
    if (mainMap) {
      const mainMapBounds = mainMap.getBounds();
      minY.value = mainMapBounds.getSouthWest().lat;
      maxY.value = mainMapBounds.getNorthEast().lat;
      minX.value = mainMapBounds.getSouthWest().lng;
      maxX.value = mainMapBounds.getNorthEast().lng;
    }

    track(FunctionIdEnum.globalLayer_export_selectBounds, EventTypeEnum.CLICK);
  };

  const showDrawer = () => {
    dialogVisible.value = true;
  };

  const confirmDrawer = () => {
    dialogVisible.value = false;
    if (coordinates) {
      minY.value = coordinates[0][0].lat;
      maxY.value = coordinates[0][2].lat;
      minX.value = coordinates[0][0].lng;
      maxX.value = coordinates[0][2].lng;
      refreshMainMapByExtent();
    }
  };

  return {
    initDrawMap,
    startDraw,
    refreshExtentByMainMap,
    refreshMainMapByExtent,
    showDrawer,
    confirmDrawer,
    minY,
    maxY,
    minX,
    maxX,
    extentVisible,
    dialogVisible,
  };
}
